import { theme } from '@approvalmax/theme';
import styled from 'styled-components';

export const Main = styled.main`
    display: grid;
    grid-template-columns: 1fr auto 334px;
    grid-template-rows: 1fr;

    @media (max-width: ${theme.container.breakpoint.medium}) {
        grid-template-columns: 1fr auto 294px;
    }

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        grid-template-columns: 1fr;
        grid-template-rows: 1fr;
    }
`;
